// Zinsdelen voor de samenvatting van een herhaling (Turks). Zelfde vorm als recurrenceApp.nl.ts.
export const appRecurrenceTr = {
    once: 'Tek seferlik',
    everyDay: 'Her gün',
    everyWorkday: 'Her hafta içi',
    everyWeek: 'Her hafta',
    everyMonth: 'Her ay',
    everyYear: 'Her yıl',
    everyWeekdays: 'Her {days}',
    otherDay: 'Gün aşırı',
    otherWeek: 'İki haftada bir',
    otherMonth: 'İki ayda bir',
    otherYear: 'İki yılda bir',
    nDays: { one: '{count} günde bir', other: '{count} günde bir' },
    nWeeks: { one: '{count} haftada bir', other: '{count} haftada bir' },
    nMonths: { one: '{count} ayda bir', other: '{count} ayda bir' },
    nYears: { one: '{count} yılda bir', other: '{count} yılda bir' },
    dailyOnlyOn: '{period}, yalnızca {days}',
    weeklyOn: '{period}, {days}',
    weeklyAllDays: '{period}, her gün',
    weeklyWorkdays: '{period}, hafta içi',
    monthlyOrdinal: 'Her ayın {ordinals}',
    monthlyOrdinalPeriod: '{period}, ayın {ordinals}',
    monthlyOn: '{period}, {days}',
    ifWeekday: '{text}, {days} gününe denk gelirse',
    monthDay: '{day}. gün',
    lastDay: 'son gün',
    nthLastDay: '{ordinal} gün',
    yearlyOrdinal: '{period}, {months} ayının {ordinals}',
    yearlyOn: '{period}, {date}',
    yearlyDays: '{period}, {months} ayında {days}',
    dayMonth: '{day} {month}',
    ordinalWeekday: '{ordinals} {weekday} günü',
    anyWeekday: 'her {weekday}',
    ord1: 'birinci',
    ord2: 'ikinci',
    ord3: 'üçüncü',
    ord4: 'dördüncü',
    ord5: 'beşinci',
    ordLast: 'son',
    ordLast2: 'sondan ikinci',
    ordLast3: 'sondan üçüncü',
    ordLast4: 'sondan dördüncü',
    ordLast5: 'sondan beşinci',
    ordN: '{n}.',
    evenWeeks: '{text}, çift haftalarda',
    oddWeeks: '{text}, tek haftalarda',
    at: '{text}, saat {time}',
    fromTo: '{text}, {start}–{end}',
    times: { one: '{text}, {count} kez', other: '{text}, {count} kez' },
    until: '{text}, {date} tarihine kadar',
    listAnd: '{a} ve {b}',
    listSep: ', ',
};
//# sourceMappingURL=recurrenceApp.tr.js.map